import { render, staticRenderFns } from "./sidenavbaritem.vue?vue&type=template&id=a4cd77a2&"
import script from "./sidenavbaritem.vue?vue&type=script&lang=js&"
export * from "./sidenavbaritem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports